import { render, staticRenderFns } from "./subAll.vue?vue&type=template&id=db413744&scoped=true&"
import script from "./subAll.vue?vue&type=script&lang=js&"
export * from "./subAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db413744",
  null
  
)

export default component.exports